import Model from './Model';

export default class Role extends Model {
    static name = 'Role'

    _fillable = [
      'id', 'number', 'name', 'display_name',
      'created_at', 'updated_at'
    ]

    _casts = {
      number: 'integer',
    }
}
